/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { PaymentMethodPrimaryPathParams, PaymentMethodPrimaryResponse } from '../types/PaymentMethodPrimary'

/**
 * PATCH /:organisation/payment-methods/:paymentMethod/primary
 * @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::primary
 */
export async function paymentMethodPrimary(
	organisation: PaymentMethodPrimaryPathParams['organisation'],
	paymentMethod: PaymentMethodPrimaryPathParams['paymentMethod'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<PaymentMethodPrimaryResponse>> {
	return axiosInstance.patch(`/${organisation}/payment-methods/${paymentMethod}/primary`, undefined, config)
}
